import SEO from "@/components/common/SEO";
import LegalLayout from "./LegalLayout";

import {
  organizationSchema,
  breadcrumbSchema,
} from "../../components/common/schema";

const schemas = [
  organizationSchema(),

  breadcrumbSchema([
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Grievance Redressal",
      path: "/grievance-redressal",
    },
  ]),
];

export default function GrievanceRedressal() {
  return (
    <>
      <SEO
        title="Grievance Redressal"
        description="Learn about Money Mart's grievance redressal process, complaint resolution timelines and contact details."
        canonical="/grievance-redressal"
        structuredData={schemas}
      />
      <LegalLayout
        title="Grievance Redressal"
        description="Money Mart is committed to providing prompt, transparent, and fair resolution of customer grievances related to our loan advisory services."
        lastUpdated="24 July 2026"
      >
        <h2>1. Our Commitment</h2>

        <p>
          At Money Mart, customer satisfaction is one of our highest priorities.
          We strive to provide professional, transparent, and timely loan
          advisory services. If you are dissatisfied with any aspect of our
          services, we encourage you to share your concerns with us so that we
          can investigate and resolve them promptly.
        </p>

        <br />

        <h2>2. What You Can Raise a Complaint About</h2>

        <p>
          You may contact us regarding concerns including, but not limited to:
        </p>

        <ul>
          <li>Loan application assistance.</li>
          <li>Service quality.</li>
          <li>Communication delays.</li>
          <li>Incorrect information provided by our representatives.</li>
          <li>Document handling concerns.</li>
          <li>Privacy-related issues.</li>
          <li>Behaviour of our employees or representatives.</li>
          <li>Any other issue related to our advisory services.</li>
        </ul>

        <br />

        <h2>3. How to Submit a Grievance</h2>

        <p>
          You may raise your grievance using any of the following communication
          channels:
        </p>

        <ul>
          <li>Email</li>
          <li>Telephone</li>
          <li>WhatsApp</li>
          <li>Written communication</li>
          <li>In-person visit to our office during business hours</li>
        </ul>

        <p>Please provide, wherever applicable:</p>

        <ul>
          <li>Your full name.</li>
          <li>Registered mobile number.</li>
          <li>Email address.</li>
          <li>Loan application or enquiry reference number.</li>
          <li>Description of your grievance.</li>
          <li>Supporting documents or screenshots, if available.</li>
        </ul>

        <br />

        <h2>4. Resolution Process</h2>

        <p>
          Upon receiving your grievance, our customer support team will register
          your complaint and begin an internal review.
        </p>

        <p>Our grievance resolution process generally includes:</p>

        <ul>
          <li>Acknowledgement of the complaint.</li>
          <li>Review of the facts and supporting documents.</li>
          <li>Communication with the concerned team or representative.</li>
          <li>Resolution or clarification provided to the customer.</li>
          <li>Closure confirmation.</li>
        </ul>

        <br />

        <h2>5. Resolution Timeline</h2>

        <p>
          We aim to acknowledge all grievances within{" "}
          <strong>2 business days</strong> of receipt.
        </p>

        <p>
          Most grievances are resolved within <strong>7 business days</strong>.
          More complex matters requiring coordination with Banks, NBFCs, or
          third-party service providers may require additional time.
        </p>

        <br />

        <h2>6. Complaints Relating to Banks or NBFCs</h2>

        <p>
          Money Mart acts only as a loan advisory and Bank Channel Partner
          (DSA). Final decisions regarding loan approval, sanction,
          documentation, interest rates, fees, and disbursement are made solely
          by the respective RBI-regulated Bank or NBFC.
        </p>

        <p>
          Where your grievance relates directly to the lending institution, we
          will make reasonable efforts to guide you towards the appropriate
          grievance mechanism of the concerned Bank or NBFC.
        </p>

        <br />

        <h2>7. Customer Responsibilities</h2>

        <p>
          To help us resolve your grievance efficiently, you are requested to:
        </p>

        <ul>
          <li>Provide accurate information.</li>
          <li>Submit complete supporting documents.</li>
          <li>Respond promptly to requests for additional information.</li>
          <li>Maintain courteous communication with our representatives.</li>
        </ul>

        <br />

        <h2>8. Privacy of Grievances</h2>

        <p>
          All grievances and supporting information submitted to Money Mart are
          handled confidentially and processed in accordance with our Privacy
          Policy. Information will only be shared where necessary for complaint
          investigation or where required by applicable law.
        </p>

        <br />

        <h2>9. Contact Details</h2>

        <p>
          You may contact our Grievance Redressal Officer using the details
          below:
        </p>

        <p>
          <strong>Grievance Redressal Officer</strong>
          <br />
          Money Mart
        </p>

        <p>
          <strong>Email:</strong> contact@money-mart.in
          <br />
          <strong>Phone:</strong> +91-9214417434
          <br />
          <strong>Office Hours:</strong> Monday – Saturday, 10:00 AM – 7:00 PM
        </p>

        <p>
          <strong>Office Address:</strong>
          <br />
          Money Mart
          <br />
          1st A-B Rd, Opposite Gold Plaza, Sardarpura, Jodhpur, Rajasthan 342003
        </p>

        <br />

        <h2>10. Changes to this Policy</h2>

        <p>
          Money Mart reserves the right to update this Grievance Redressal
          Policy at any time to reflect changes in our services, business
          operations, or applicable legal requirements.
        </p>

        <p>
          The latest version will always be available on this page along with
          the revision date.
        </p>
      </LegalLayout>
    </>
  );
}
